<template>
    <el-card class="el-card-big mead-bike-map" :body-style="{height: '100%','padding-top':'1px'}">
        <template #header>
            <content-header/>
        </template>
        <div class="filters" display:flex>
            <span>选择区域：</span>
            <el-select
                v-model="area_id"
                @change="AreaChange"
                size="small"
                placeholder="请选择"
                class="selectwidth"
            >
                <el-option
                    v-for="item in put_areas"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                />
            </el-select>
        </div>
        <el-row type="flex" style="height: calc(100% - 48px);">
            <div class="amap-page-container">
                <el-amap-search-box
                    class="search-box"
                    placeholder="请输入搜索地址"
                    :search-option="searchOption"
                    :on-search-result="onSearchResult"
                />
                <el-amap
                    vid="amap"
                    :plugin="plugin"
                    class="amap-demo"
                    :center="center"
                    :default-cursor="defaultCursor"
                    :zoom="zoom"
                    :amap-manager="amapManager"
                    :events="events"
                >
                    <el-amap-marker v-for="(marker1,index) in markers1" :key="'infomarkerss-'+index"
                                    :position="marker1"/>
                    <el-amap-marker
                        v-for="(marker,index) in markers"
                        :key="'infomarker-'+index"
                        :position="marker.position"
                        :z-index="marker.zIndex"
                        :events="marker.events"
                        :icon="marker.icon"
                    />
                    <el-amap-info-window
                        v-if="window"
                        :position="window.position"
                        :visible="window.visible"
                        :content="window.content"
                    />
                    <el-amap-circle
                        v-for="(circle,index) in circles"
                        :key="'info2-'+index"
                        :center="circle.center"
                        :radius="circle.radius"
                        :fill-opacity="circle.fillOpacity"
                        :stroke-opacity="circle.strokeOpacity"
                        :stroke-color="circle.strokeColor"
                        :stroke-style="circle.strokeStyle"
                        :fill-color="circle.fillColor"
                        :events="circle.events"
                    />
                    <el-amap-polygon
                        v-for="(polygon, index) in polygons"
                        :key="index"
                        :vid="index"
                        :editable="polygon_editable"
                        :ref="`polygon_${index}`"
                        :path="polygon.path"
                        :draggable="polygon.draggable"
                        :fill-opacity="polygon.fillOpacity"
                        :stroke-color="polygon.strokeColor"
                        :stroke-style="polygon.strokeStyle"
                        :fill-color="polygon.fillColor"
                        :events="polygon.events"
                    />
                    <el-amap-polygon
                        v-for="(polygon, index) in polygonsarea"
                        :key="'infopolygonsarea-'+index"
                        :vid="index"
                        :ref="`polygon_${index}`"
                        :path="polygon.path"
                        :fill-opacity="polygon.fillOpacity"
                        :draggable="polygon.draggable"
                        :events="polygon.events"
                    />
                    <el-button-group class="info">
                        <el-button type="primary" :disabled="addFenceDisabled" @click="addFence">开始绘制</el-button>
                        <el-button type="primary" @click="removeFence">清除围栏</el-button>
                    </el-button-group>
                </el-amap>
            </div>
            <div class="tabs-class mead-tabs-class">
                <el-tabs
                    type="border-card"
                    :stretch="true"
                    v-model="activeName"
                    @tab-click="getParking"
                    style="height:100%;"
                >
                    <el-tab-pane name="2" style="height:100%;">
                        <span slot="label"><i class="el-icon-date"/> 停车区</span>
                        <el-row>
                            <div class="sear">
                                <el-input
                                    placeholder="请输入内容"
                                    v-model="searchs"
                                    size="mini"
                                    class="searchs"
                                >
                                    <el-button slot="append" @click="searchParking2" icon="el-icon-search"/>
                                </el-input>
                                <el-button size="mini" type="primary" @click="addParking1">添加停车区</el-button>
                            </div>
                        </el-row>

                        <div class="dot-list">
                            <div
                                class="dot-item"
                                v-for="(row, key) in parkings2"
                                :key="row.id"
                                :class="{'gary':(row.id === click_index)}"
                            >
                                <div class="dot-main" @click="rowClick(row,key)">
                                    <div class="title">{{ row.name }}</div>
                                    <div class="time">{{ row.updated_at }}</div>
                                </div>
                                <div class="dot-main">
                                    <div class="unlock">
                                        <span>是否开启</span>
                                        <el-switch
                                            v-model="row.status"
                                            active-color="#13ce66"
                                            inactive-color="#ff4949"
                                            class="switch"
                                            @change="ChangeStatus(row.id,row.status)"
                                        />
                                    </div>
                                    <div data-v-3971c298="" class="action">
                                        <span @click="handleClick(row)">编辑</span>
                                        <span @click.stop="destoryComfirm(key,row.id,row.type)">删除</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>

                    <el-tab-pane label="禁停区" name="1" style="height:100%;">
                        <el-row>
                            <div class="sear">
                                <el-input
                                    placeholder="请输入内容"
                                    v-model="searchs"
                                    size="mini"
                                    class="searchs"
                                >
                                    <el-button slot="append" @click="searchParking1" icon="el-icon-search"/>
                                </el-input>
                                <el-button size="mini" type="primary" @click="addParking2">添加禁停区</el-button>
                            </div>
                        </el-row>

                        <div class="dot-list">
                            <div
                                class="dot-item"
                                v-for="(row, key) in parkings"
                                :key="key"
                                :class="{'gary':(row.id === click_index)}"
                            >
                                <div class="dot-main" @click="rowClick(row,key)">
                                    <div class="title">{{ row.name }}</div>
                                    <div class="time">{{ row.updated_at }}</div>
                                </div>
                                <div class="dot-main">
                                    <div class="unlock">
                                        <span>是否开启</span>
                                        <el-switch
                                            v-model="row.status"
                                            active-color="#13ce66"
                                            inactive-color="#ff4949"
                                            class="switch"
                                            @change="ChangeStatus(row.id,row.status)"
                                        />
                                    </div>
                                    <div data-v-3971c298="" class="action">
                                        <span @click="handleClick(row)">编辑</span>
                                        <span @click.stop="destoryComfirm(key,row.id,row.type)">删除</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="运维分区" name="3" style="height:100%;">
                        <el-row>
                            <div class="sear">
                                <el-input
                                    placeholder="请输入内容"
                                    v-model="searchs"
                                    size="mini"
                                    class="searchs"
                                >
                                    <el-button slot="append" @click="searchParking(3)" icon="el-icon-search"/>
                                </el-input>
                                <el-button size="mini" type="primary" @click="addParking(3)">添加运维分区</el-button>
                            </div>
                        </el-row>

                        <div class="dot-list">
                            <div
                                class="dot-item"
                                v-for="(row, key) in parkings"
                                :key="key"
                                :class="{'gary':(row.id === click_index)}"
                            >
                                <div class="dot-main" @click="rowClick(row,key)">
                                    <div class="title">{{ row.name }}</div>
                                    <div class="time">{{ row.updated_at }}</div>
                                </div>
                                <div class="dot-main">
                                    <div class="unlock">
                                        <span>是否开启</span>
                                        <el-switch
                                            v-model="row.status"
                                            active-color="#13ce66"
                                            inactive-color="#ff4949"
                                            class="switch"
                                            @change="ChangeStatus(row.id,row.status)"
                                        />
                                    </div>
                                    <div data-v-3971c298="" class="action">
                                        <span @click="handleClickLink(row)">编辑</span> 
                                        <span @click.stop="destoryComfirm(key,row.id,row.type)">删除</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-dialog
                        title="添加停车区域"
                        :visible.sync="dialogVisible"
                        width="30%"
                        :before-close="handleClose"
                    >
                        <lz-form
                            ref="form"
                            :get-data="getData"
                            :submit="onSubmit"
                            :errors.sync="errors"
                            :form="form"
                            :edit-mode="editMode"
                            :rules="rules"
                            :disable-redirect="true"
                            label-width="30%"
                            style="width:100%;"
                        >
                            <el-form-item label="所属大区" required prop="areas">
                                <el-select
                                    filterable
                                    clearable
                                    v-model="form.area_id"
                                    placeholder="请选择"
                                    class="limitwidth"
                                >
                                    <el-option
                                        v-for="item in put_areas"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    />
                                </el-select>
                            </el-form-item>

                            <el-form-item label="停车区域名称" required prop="name">
                                <el-input v-model="form.name" class="limitwidth"/>
                            </el-form-item>
                            <el-form-item label="区域类型" required prop="type">
                                <el-select
                                    filterable
                                    clearable
                                    v-model="form.type"
                                    placeholder="请选择"
                                    class="limitwidth"
                                >
                                    <el-option
                                        key="1"
                                        label="禁停区"
                                        value="1"
                                    />
                                    <el-option
                                        key="2"
                                        label="停车区"
                                        value="2"
                                    />
                                    <el-option
                                        key="3"
                                        label="运维分区"
                                        value="3"
                                    />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="停车上限" v-show="show_max_number" prop="max_number">
                                <el-input
                                    v-model="form.max_number"
                                    class="limitwidth"
                                    onkeyup="this.value=this.value.replace(/[^\d.]/g,'');"
                                />
                            </el-form-item>
                            <el-form-item label="区域状态" required prop="status">
                                <el-switch
                                    style="display: block"
                                    v-model="form.status"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                    active-text="正常"
                                    inactive-text="禁用"
                                />
                            </el-form-item>
                            <el-form-item label="围栏区域" prop="form_fence">
                                <el-input
                                    type="textarea"
                                    class="limitwidth"
                                    required
                                    v-model="form.form_fence"
                                    disabled
                                />
                                <el-button
                                    size="medium"
                                    type="primary"
                                    @click="clickEditFence"
                                >
                                    绘制围栏
                                </el-button>
                            </el-form-item>
                        </lz-form>

                        <span slot="footer" class="dialog-footer"/>
                    </el-dialog>
                </el-tabs>
            </div>
        </el-row>
    </el-card>
</template>

<script>

    import LzForm from '@c/LzForm'
    import VueAMap from 'vue-amap'
    import {getAreas, showArea} from '@/api/area'
    import {storeParking, getParkings, updateParkingStatus, updateParking, destroyParking} from '@/api/parking'
    import FormHelper from '@c/LzForm/FormHelper'
    import {getBikes} from '@/api/bike'
    import RowToEdit from "@c/LzTable/RowToEdit";

    export default {
        name: 'Index',
        components: {
            LzForm,
            RowToEdit
        },
        mixins: [
            FormHelper,
        ],
        data() {
            let self = this
            let amapManager = new VueAMap.AMapManager()
            return {
                click_index: undefined,
                put_areas: [
                    // {
                    //   id: null,
                    //   name: '全部',
                    // },
                ],
                area_id: '0',
                is_round_show: [],
                center: [121.59996, 31.197646],
                defaultCursor: 'pointer',
                zoom: 12,
                lng: 0,
                lat: 0,
                loaded: false,
                amapManager: amapManager,
                fenceForm: [],
                markers1: [],
                events: {
                    init(o) {

                    },
                },
                mouseTool: null,
                searchOption: {
                    city: '郑州',
                    citylimit: false,
                },
                plugin: [{
                    pName: 'MapType',
                    defaultType: 0,
                    events: {
                        init(o) {
                            // console.log(o)
                        },
                    },
                }, {
                    pName: 'Geolocation',
                    events: {
                        init(o) {
                            // o 是高德地图定位插件实例
                            // console.log(o)
                            o.getCurrentPosition((status, result) => {
                                // 未配置https  定位失败 暂时手动配置
                                self.lng = 113.73350255780726
                                self.lat = 34.78024666564106
                                self.center = [self.lng, self.lat]
                                self.loaded = true
                                if (result && result.position) {
                                    self.lng = result.position.lng
                                    self.lat = result.position.lat
                                    self.center = [self.lng, self.lat]
                                    self.loaded = true
                                    self.$nextTick()
                                }
                            })
                        },
                    },
                }, {
                    pName: 'Scale',
                    // offset: { x: 1, y: 1 },
                    position: 'RB',
                    events: {
                        init(instance) {

                        },
                    },
                }, {
                    pName: 'ToolBar',
                    events: {
                        init(instance) {
                            // console.log(instance)
                        },
                    },
                }],
                circles: [],
                polygons: [],
                polygonsarea: [ // 运营骑行区域
                    {
                        draggable: false,
                        path: [],
                        fillOpacity: 0.1,
                        events: {
                            click: () => {

                            },
                        },
                    },
                ],
                markers: [],
                windows: [],
                window: '',
                isedit: false, // 是否编辑停车区
                polygon_editable: false,
                activeName: '2',
                parkings: [],
                parkings2: [],
                show_max_number: true,
                dialogVisible: false,
                searchs: '',
                form: {
                    id: Number,
                    type: '2',
                    area_id: '',
                    name: '',
                    max_number: 0,
                    parking_fence: [],
                    form_fence: '',
                    status: true,
                },
                is_parking_fushe: true,
                areas: [],
                errors: {},
                rules: {},
                addFenceDisabled: false,
            }
        },
        watch: {
            // $route: {
            //   handler(newVal) {
            //     console.log(newVal)
            //   },
            // },
        },
        inject: ['reload'],
        async created() {
            const [{data: areas}] = await Promise.all([
                getAreas({all: 1}),
            ])

            areas.map((item) => {
                if (!item.areaSetting.is_parking_fushe) {
                    this.is_round_show.push(item.id)
                }
            })

            this.put_areas.push.apply(this.put_areas, areas)
            var areaId = this.$route.params.area_id || 0
            if (areaId !== 0) {
                this.area_id = parseInt(areaId)
                this.AreaChange()
            } else {
                this.area_id = this.put_areas[0].id
                this.getParking()
            }
        },
        methods: {
            clickEditFence(){
                this.dialogVisible = false
                if(this.isedit) {
                    this.polygons = []
                    this.markers = []
                    this.polygon_editable = true
                    var data = []
                    data.push(this.form)
                    this.initMapMead(data)
                }
            },
            onSearchResult(pois) {
                this.markers1 = []
                let latSum = 0
                let lngSum = 0
                if (pois.length > 0) {
                    pois.forEach(poi => {
                        let {lng, lat} = poi
                        lngSum += lng
                        latSum += lat
                        this.markers1.push([poi.lng, poi.lat])
                    })
                    let center = {
                        lng: lngSum / pois.length,
                        lat: latSum / pois.length,
                    }
                    this.center = [center.lng, center.lat]
                }
            },
            async AreaChange() {
                // console.log(this.area_id)
                // console.log(1111)
                if (this.area_id == null) {
                    this.getParking()
                    this.polygonsarea[0].path = []
                    return
                }
                // 渲染骑行区
                const [
                    {data: darea},
                ] = await Promise.all([
                    showArea(this.area_id),
                ])
                this.center = JSON.parse(darea.area_centre)
                this.zoom = 15
                this.polygonsarea[0].path = JSON.parse(darea.area_fence)
                this.is_parking_fushe = darea.areaSetting.is_parking_fushe
                // 取出此区域的停车区
                const [
                    {data},
                ] = await Promise.all([
                    getParkings({type: this.activeName, area_id: this.area_id}),
                ])

                this.parkings = data
                if(this.activeName == 2){
                    this.parkings2 = data
                }

                this.initMapMead(data)

                // console.log(2)
                // this.parkings = data
                // var banColor = 'red'
                // var icon = ''
                // if (this.activeName == 2) {
                //     this.parkings2 = data
                //     this.banColor = 'green'
                //     this.icon = 'http://resource.bike.hanyiyun.com/admin/parking_small.png'
                // }else if (this.activeName == 3) {
                //     this.banColor = 'green'
                //     this.icon = 'http://resource.bike.hanyiyun.com/admin/parking_small.png'
                // } else {
                //     this.banColor = 'red'
                //     this.icon = 'http://resource.bike.hanyiyun.com/admin/ban_small_20200325162400.png'
                // }
                // let self = this
                // var datas = data // 所有停车区遍历显示
                // let markers = []
                // let windows = []
                // let polygons = []
                // let circles = []
                //
                // datas.forEach((item, i) => {
                //     var strokeStyle = 'solid'
                //     if (!item.status) {
                //         strokeStyle = 'dashed'
                //     }
                //     item.parking_centre = JSON.parse(item.parking_centre)
                //     markers.push({
                //         position: item.parking_centre,
                //         icon: this.icon,
                //         zIndex: 500,
                //         events: {
                //             click() {
                //                 // console.log(22)
                //                 self.windows.forEach(window => {
                //                     window.visible = false
                //                 })
                //                 // console.log(item.id)
                //                 self.click_index = item.id
                //                 self.window = self.windows[i]
                //                 self.$nextTick(() => {
                //                     self.window.visible = true
                //                 })
                //             },
                //         },
                //     })
                //
                //     polygons.push({
                //         draggable: false,
                //         strokeOpacity: 0.1,
                //         fillOpacity: 0.5,
                //         fillColor: this.banColor,
                //         strokeColor: this.banColor,
                //         strokeStyle: strokeStyle,
                //         path: item.parking_fence,
                //         events: {
                //             change: () => {
                //             },
                //             click: () => {
                //
                //             },
                //         },
                //     })
                //     if (this.activeName == 2) {
                //         if (this.is_round_show.indexOf(item.area_id) == -1) {
                //             circles.push({
                //                 center: item.parking_centre,
                //                 radius: item.parking_radius,
                //                 fillColor: this.banColor,
                //                 strokeColor: this.banColor,
                //                 strokeStyle: strokeStyle,
                //                 fillOpacity: 0.1,
                //                 events: {
                //                     click: () => {
                //                         // alert('click')
                //                     },
                //                 },
                //             })
                //         }
                //
                //     }
                //
                //     windows.push({
                //         position: item.parking_centre,
                //         content: `<div class="list-infoWindow">
                //         <div class="title">信息</div>
                //         <p class="list-item">还车点名称：<span>` + item.name + `</span></p>
                //         <p class="list-item">创建时间：<span>` + item.created_at + `</span></p>
                //     </div>`,
                //         visible: false,
                //     })
                // })
                // this.markers = markers
                // this.windows = windows
                // this.circles = circles
                // if (this.is_parking_fushe) {
                //     this.circles = circles
                // } else {
                //     this.circles = []
                // }
                // this.polygons = polygons
            },
            async onSubmit() {
                if (this.isedit) {
                    await updateParking(this.form.id, this.form)
                    this.getData()
                    this.getParking()
                    this.removeFence()
                } else {
                    this.dialogVisible = false
                    await storeParking(this.form)
                    this.getData()
                    this.getParking()
                    this.removeFence()
                    this.clearForm()
                }
            },

            initMapMead(data) {
                var banColor = 'red'
                var icon = ''
                if (this.activeName == 2) {
                    this.banColor = 'green'
                    this.icon = 'http://resource.bike.hanyiyun.com/admin/parking_small.png'
                }else if (this.activeName == 3) {
                    this.banColor = 'green'
                    this.icon = 'http://resource.bike.hanyiyun.com/admin/parking_small.png'
                } else {
                    this.banColor = 'red'
                    this.icon = 'http://resource.bike.hanyiyun.com/admin/ban_small_20200325162400.png'
                }

                let self = this
                var datas = data // 所有停车区遍历显示
                let markers = []
                let windows = []
                let polygons = []
                let circles = []

                datas.forEach((item, i) => {
                    var strokeStyle = 'solid'
                    if (!item.status) {
                        strokeStyle = 'dashed'
                    }
                    item.parking_centre = JSON.parse(item.parking_centre)
                    markers.push({
                        position: item.parking_centre,
                        icon: this.icon,
                        zIndex: 500,
                        events: {
                            click() {
                                // console.log(22)
                                self.windows.forEach(window => {
                                    window.visible = false
                                })
                                // console.log(item.id)
                                self.click_index = item.id
                                self.window = self.windows[i]
                                self.$nextTick(() => {
                                    self.window.visible = true
                                })
                            },
                        },
                    })

                    polygons.push({
                        draggable: false,
                        strokeOpacity: 0.1,
                        fillOpacity: 0.5,
                        fillColor: this.banColor,
                        strokeColor: this.banColor,
                        strokeStyle: strokeStyle,
                        path: item.parking_fence,
                        events: {
                            change: () => {
                            },
                            click: () => {

                            },
                        },
                    })

                    if (this.activeName == 2) {
                        if (this.is_round_show.indexOf(item.area_id) == -1) {
                            circles.push({
                                center: item.parking_centre,
                                radius: item.parking_radius,
                                fillColor: this.banColor,
                                strokeColor: this.banColor,
                                strokeStyle: strokeStyle,
                                fillOpacity: 0.1,
                                events: {
                                    click: () => {
                                        // alert('click')
                                    },
                                },
                            })
                        }
                    }

                    windows.push({
                        position: item.parking_centre,
                        content: `<div class="list-infoWindow">
                        <div class="title">信息</div>
                        <p class="list-item">还车点名称：<span>` + item.name + `</span></p>
                        <p class="list-item">创建时间：<span>` + item.created_at + `</span></p>
                    </div>`,
                        visible: false,
                    })
                })

                this.markers = markers
                this.windows = windows
                this.circles = circles
                if (this.is_parking_fushe) {
                    this.circles = circles
                } else {
                    this.circles = []
                }
                this.polygons = polygons
            },
            // clearForm() {
            //   this.form.name = ''
            //   this.form.max_number = ''
            //   this.form.parking_fence = []
            //   this.form.form_fence = ''
            //   // area_id: '',
            //   // name: '',
            //   // max_number: 0,
            //   // parking_fence: [],
            //   // form_fence: '',
            // },
            async getData() {
                const [
                    {data: areas},
                ] = await Promise.all([
                    getAreas({all: 1}),
                ])

                this.areas = areas
                areas.map((item) => {
                    if (!item.areaSetting.is_parking_fushe) {
                        this.is_round_show.push(item.id)
                    }
                })

                if (this.isedit) {
                    console.log('编辑')
                }
            },
            async getParking() {
                 let params = {type: this.activeName, area_id: this.area_id}
                if(this.searchs){
                    params.name  = this.searchs
                }
                const [
                    {data},
                ] = await Promise.all([
                    getParkings(params),
                ])
                // console.log(3)
                if (this.window !== '') {
                    this.window.visible = false // 去掉信息弹窗
                }
                this.parkings = data
                var banColor = 'red'
                var icon = ''
                if (this.activeName == 2) {
                    this.parkings2 = data
                    this.banColor = 'green'
                    this.icon = 'http://resource.bike.hanyiyun.com/admin/parking_small.png'
                } else if (this.activeName == 3) {
                    this.banColor = 'green'
                    this.icon = 'http://resource.bike.hanyiyun.com/admin/parking_small.png'
                } else {
                    this.banColor = 'red'
                    this.icon = 'http://resource.bike.hanyiyun.com/admin/ban_small_20200325162400.png'
                }
                let self = this
                var datas = data // 所有停车区遍历显示
                let markers = []
                let windows = []
                let polygons = []
                let circles = []

                datas.forEach((item, i) => {
                    // 轮廓线样式，实线:solid，虚线:dashed

                    var strokeStyle = 'solid'
                    if (!item.status) {
                        strokeStyle = 'dashed'
                    }
                    item.parking_centre = JSON.parse(item.parking_centre)
                    markers.push({
                        position: item.parking_centre,
                        icon: this.icon,
                        events: {
                            click() {
                                // console.log(23)
                                self.windows.forEach(window => {
                                    window.visible = false
                                })
                                self.click_index = item.id
                                // console.log(item.id)
                                self.window = self.windows[i]
                                self.$nextTick(() => {
                                    self.window.visible = true
                                })
                            },
                        },
                    })

                    polygons.push({
                        draggable: false,
                        strokeOpacity: 0.1,
                        fillOpacity: 0.5,
                        fillColor: this.banColor,
                        strokeColor: this.banColor,
                        strokeStyle: strokeStyle,
                        path: item.parking_fence,
                        events: {
                            change: () => {
                            },
                            click: () => {

                            },
                        },
                    })
                    if (this.activeName == 2) {
                        if (this.is_round_show.indexOf(item.area_id) == -1) {
                            circles.push({
                                center: item.parking_centre,
                                radius: item.parking_radius,
                                fillColor: this.banColor,
                                strokeColor: this.banColor,
                                fillOpacity: 0.1,
                                strokeStyle: strokeStyle,
                                events: {
                                    click: () => {
                                        // alert('click')
                                    },
                                },
                            })
                        }

                    }

                    windows.push({
                        position: item.parking_centre,
                        content: `<div class="list-infoWindow">
                        <div class="title">信息</div>
                        <p class="list-item">还车点名称：<span>` + item.name + `</span></p>
                        <p class="list-item">创建时间：<span>` + item.created_at + `</span></p>
                    </div>`,
                        visible: false,
                    })
                })
                this.markers = markers
                this.windows = windows
                this.circles = circles
                this.polygons = polygons
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        this.form.type = ''
                        this.form.area_id = ''
                        this.form.max_number = ''
                        this.form.parking_fence = ''
                        this.form.name = ''
                        done()
                    })
                    .catch(_ => {
                        this.form.type = ''
                        this.form.area_id = ''
                        this.form.max_number = ''
                        this.form.parking_fence = ''
                        this.form.name = ''
                    })
            },
            clearForm() {
                this.form.type = ''
                this.form.area_id = ''
                this.form.max_number = ''
                this.form.parking_fence = ''
                this.form.name = ''
                this.form.form_fence = ''
            },
            addParking1() {
                // 停车区
                this.isedit = false
                this.form.type = '2'
                this.form.area_id = this.area_id
                this.show_max_number = true
                this.dialogVisible = true
            },
            addParking2() {
                // 禁停车区
                this.isedit = false
                this.form.type = '1'
                this.dialogVisible = true
                this.form.area_id = this.area_id
                this.show_max_number = false
            },
            addParking(type) {
                // 禁停车区
                this.isedit = false
                this.form.type = type.toString()
                this.dialogVisible = true
                this.form.area_id = this.area_id
                this.show_max_number = false
            },
            async ChangeStatus(parkingId, status) {
                // 改变状态
                console.log(parkingId, status)
                const [
                    {data: res},
                ] = await Promise.all([
                    updateParkingStatus({id: parkingId, status: status}),
                ])

                if (res) {
                    this.$message({
                        type: 'success',
                        message: '修改成功!',
                    })
                }
            },
            handleClickLink(row){
                this.$router.push({
                    path: '/parking/edit/' + row.id,
                    query: {id: row.id}
                })
            },
            rowClick(row, key) {
                // 点击table某行
                this.click_index = row.id
                this.center = row.parking_centre
                this.polygons[key].path = row.parking_fence
                // this.polygon_editable = true

                this.windows.forEach(window => {
                    window.visible = false
                })
                this.window = this.windows[key]
                this.$nextTick(() => {
                    this.window.visible = true
                })
                if (row.type == 2) {
                    this.circles[key].radius = row.parking_radius
                    this.circles[key].center = row.parking_centre
                }

                this.zoom = 18
            },
            handleClick(row) {
                // 编辑
                this.isedit = true
                this.dialogVisible = true
                this.form.id = row.id
                this.form.area_id = row.area_id
                this.form.name = row.name
                this.form.type = row.type.toString()
                this.form.max_number = row.max_number
                this.form.status = row.status
                this.form.parking_fence = []
                row.parking_fence.forEach(item => {
                    var im = {lat: item[0], lng: item[1]}
                    this.form.parking_fence.push(im)
                })
                this.form.form_fence = JSON.stringify(row.parking_fence)
            },
            async destoryComfirm(index, id, type) {
                var bool = confirm('确认删除吗？')
                if (bool) {
                    destroyParking(id).then(res => {
                        if (type == 2) {
                            this.parkings2.splice(index, 1)
                        } else if (type == 1) {
                            this.parkings.splice(index, 1)
                        }
                        res.then(data => {
                            if (data) {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!',
                                })
                                // console.log(111)
                                this.window.visible = false

                                this.getData()
                                this.getParking()
                                // this.reload()
                            }
                        })
                    })
                }
            },
            async searchParking1() {
                // const [
                //     {data},
                // ] = await Promise.all([
                //     getParkings({type: 1, name: this.searchs}),
                // ])

                // // console.log(4)
                // this.parkings = data
                this.getParking()
            },
            async searchParking(type) {
                // const [
                //     {data},
                // ] = await Promise.all([
                //     getParkings({type: type, name: this.searchs}),
                // ])

                // // console.log(4)
                // this.parkings = data
                this.getParking()
            },
            async searchParking2() {
                // const [
                //     {data},
                // ] = await Promise.all([
                //     getParkings({type: 2, name: this.searchs}),
                // ])
                // // console.log(5)
                // this.parkings2 = data
                this.getParking()
            },
            drawPolygon() {

            },
            addFence() {
                let _this = this
                _this.defaultCursor = 'crosshair'
                let map = this.amapManager.getMap()
                map.plugin(['AMap.MouseTool'], function () {
                    let mouseTool = new AMap.MouseTool(map)
                    _this.mouseTool = mouseTool
                    var drawPolygon = mouseTool.polygon()

                    // 添加事件
                    AMap.event.addListener(mouseTool, 'draw', function (e) {
                        _this.form.parking_fence = []
                        // 赋值真正表单需要得数据
                        e.obj.getPath().forEach(item => {
                            var im = {lat: item.lat, lng: item.lng}
                            _this.form.parking_fence.push(im)
                        })
                        // 赋值渲染表单得数据
                        _this.form.form_fence = JSON.stringify(_this.form.parking_fence)
                        _this.defaultCursor = 'pointer'
                        // 弹出表单
                        if (_this.area_id != '') {
                            _this.form.area_id = _this.area_id
                        }
                        _this.dialogVisible = true

                        //  阻止鼠标右击事件
                        document.oncontextmenu = function (e) {
                            return false // 取消右键点击的默认事件
                        }
                        _this.mouseTool.close()
                    })
                })
                this.addFenceDisabled = true
            },
            removeFence() {
                this.fenceForm = []
                this.defaultCursor = 'pointer'
                if (this.mouseTool) {
                    this.mouseTool.close(true)
                }
                this.addFenceDisabled = false
            },
        },
        // async mounted() {
        //   const [
        //     { data },
        //   ] = await Promise.all([
        //     getParkings({ type: this.activeName }),
        //   ])
        //   console.log(1)

        //   this.parkings2 = data
        //   let self = this
        //   var datas = data // 所有停车区遍历显示
        //   let markers = []
        //   let windows = []
        //   let polygons = []
        //   let circles = []
        //   var banColor = 'red'
        //   var icon = ''
        //   if (this.activeName == 2) {
        //     this.banColor = 'green'
        //     this.icon = 'http://resource.bike.hanyiyun.com/admin/parking_small.png'
        //   } else {
        //     this.banColor = 'red'
        //     this.icon = 'http://resource.bike.hanyiyun.com/admin/ban_small_20200325162400.png'
        //   }

        //   // let num = datas.length
        //   // console.log(datas)
        //   datas.forEach((item, i) => {
        //     // 轮廓线样式，实线:solid，虚线:dashed
        //     var strokeStyle = 'solid'
        //     if (!item.status) {
        //       strokeStyle = 'dashed'
        //       console.log(item)

        //       console.log(1111)
        //     }
        //     // console.log(i)
        //     item.parking_centre = JSON.parse(item.parking_centre)
        //     markers.push({
        //       position: item.parking_centre,
        //       icon: this.icon,
        //       events: {
        //         click() {
        //           // console.log(24)
        //           self.windows.forEach(window => {
        //             window.visible = false
        //           })
        //           self.click_index = item.id
        //           self.window = self.windows[i]
        //           self.$nextTick(() => {
        //             self.window.visible = true
        //           })
        //         },
        //       },
        //     })

        //     polygons.push({
        //       draggable: false,
        //       strokeOpacity: 0.1,
        //       fillOpacity: 0.5,
        //       fillColor: this.banColor,
        //       strokeColor: this.banColor,
        //       strokeStyle: strokeStyle,
        //       path: item.parking_fence,
        //       events: {
        //         change: () => {
        //         },
        //         click: () => {

        //         },
        //       },
        //     })
        //     if (this.activeName == 2) {
        //       circles.push({
        //         center: item.parking_centre,
        //         radius: item.parking_radius,
        //         fillColor: this.banColor,
        //         strokeColor: this.banColor,
        //         strokeStyle: strokeStyle,
        //         fillOpacity: 0.1,
        //         events: {
        //           click: () => {
        //             // alert('click')
        //           },
        //         },
        //       })
        //     }

        //     windows.push({
        //       position: item.parking_centre,
        //       content: `<div class="list-infoWindow">
        //                       <div class="title">信息</div>
        //                       <p class="list-item">还车点名称：<span>` + item.name + `</span></p>
        //                       <p class="list-item">创建时间：<span>` + item.created_at + `</span></p>
        //                   </div>`,
        //       visible: false,
        //     })
        //   })
        //   this.markers = markers
        //   this.windows = windows
        //   this.circles = circles
        //   this.polygons = polygons
        // },
    }
</script>
<style lang="scss" scoped>
    .el-card-big {
        height: 99%;
    }

    .amap-page-container {
        width: 80%;
        // height: 100%;
        margin-right: 5px;
        position: relative;
        top: -36px;

    }

    .search-box {
        height: 36px;
        border-radius: .25rem;
        top: 65px;
        border-width: 1px;
        left: 90px;
    }

    .tabs-class {
        width: 20%;
        min-width: 300px;
        /*height: 85%;*/
        .sear {
            display: flex;
            justify-content: space-between;
            padding: 15px !important;

            .searchs {
                width: 50%;
                //margin: 10px 10px;
            }
        }

        .dot-list {
            width: 100%;
            padding: 1px;
            overflow-y: auto;
            height: calc(100% - 100px);

            .dot-item {
                padding: 10px 15px;
                border-bottom: 1px solid rgba(0, 0, 0, .1);

                .dot-main {
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;

                    & > div:first-child {
                        -webkit-box-flex: 1;
                        -ms-flex: 1;
                        flex: 1;
                    }

                    .title {
                        cursor: pointer;
                        margin-bottom: 5px;
                        font-size: 16px;

                    }

                    .time {
                        font-size: 14px;
                        color: #999;
                    }

                    .unlock {
                        color: #666;
                        display: -webkit-box;
                        display: -ms-flexbox;
                        display: flex;
                        position: relative;

                        .switch {
                            margin-left: 12px;
                            margin-top: 3px;
                        }
                    }

                    .action {
                        color: #409eff;
                        position: relative;
                        top: 2px;

                        span:first-child {
                            margin-right: 10px;
                        }

                        span {
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }

    .amap-demo {
        position: relative;
        /*height: 85%;*/
        .info {
            border-radius: .25rem;
            position: absolute;
            top: 30px;
            width: auto;
            border-width: 0;
            right: 100px;
        }
    }

    .limitwidth {
        width: 50%;
        margin-right: 10px;
    }

    .polygon {

        background-image: "@/assets/img/polygon.png";
        cursor: pointer;
    }

    .filters {
        margin-right: 15px;
        text-align: right;
        margin: 10px;

        .selectwidth {
            padding-left: 30px;
            width: 200px;
            margin-right: 15px;
        }
    }

    .gary {
        background-color: #ccc;
    }
</style>
<style>
    .el-tabs__content {
        height: calc(100% - 15px);
    }
</style>
